import { useRef } from "react";
import * as Dialog from "@radix-ui/react-dialog";

/** Reuse the installed dialog primitive for focus trap, Escape and screen-reader labels. */
export function OpportunityDetailSheet({ title, open, onClose, children }: {
  title: string; open: boolean; onClose: () => void; children: React.ReactNode;
}) {
  const previousFocus = useRef<HTMLElement | null>(null);
  return <Dialog.Root open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-black/45" />
      <Dialog.Content className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto border-l border-border bg-background p-5 shadow-xl sm:w-[min(760px,90vw)] sm:p-7"
        onOpenAutoFocus={() => { previousFocus.current = document.activeElement as HTMLElement; }}
        onCloseAutoFocus={(event) => { event.preventDefault(); previousFocus.current?.focus(); }}>
        <div className="mb-5 flex items-start gap-3">
          <div className="min-w-0 flex-1">
            <Dialog.Title className="text-lg font-semibold break-words">{title}</Dialog.Title>
            <Dialog.Description className="mt-1 text-sm text-muted-foreground">Detalji organizacije, izvori i otvorena pitanja. Strojna procjena nije ljudsko odobrenje.</Dialog.Description>
          </div>
          <Dialog.Close aria-label="Zatvori detalje" className="shrink-0 rounded border border-border px-3 py-2 text-sm">Zatvori ×</Dialog.Close>
        </div>
        {children}
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>;
}
